<template>
    <div class="users">
        <header class="panel__header">
            <aside>
                <h2 class="panel__title"><slot name="title">Manage people</slot></h2>
                <p class="panel__subtitle"><slot name="subtitle"></slot></p>
            </aside>
            <slot name="header"></slot>
        </header>

        <header class="users__header">
            <aside class="users__search">
                <input type="text" ref="input" v-model.trim="query" :placeholder="`Search for people`" class="form__input users__input"/>
                <icon type="search" color="gray" size="20"></icon>
            </aside>
        </header>

        <table v-if="hasUsers" class="lc-users-table table">
            <thead>
                <th></th>
                <th>User</th>
                <th>Role</th>
                <th v-if="admin">Channels</th>
                <th>Last login</th>
                <th v-if="currentUser.is_not_guest"></th>
            </thead>
            <tbody>
                <tr data-locator="user-row" :key="user.id" v-for="user in filteredUsers" :class="{ 'is-disabled': user.is_inactive }">
                    <td>
                        <avatar :user="user" />
                    </td>
                    <td>
                        <p v-if="!user.is_pending" class="table__heading">
                            <strong>{{ user.display_name }}</strong>
                        </p>
                        <p>{{ user.email }}</p>
                    </td>
                    <td>
                        {{ user.role_name }}
                    </td>
                    <td v-if="admin">{{ user.channels.length }}</td>
                    <td>
                        <span v-if="user.is_pending">Pending</span>
                        <template v-else>
                            <relative-time v-if="user.last_login_timestamp" :timestamp="user.last_login_timestamp"></relative-time>
                            <template v-else>-</template>
                        </template>
                    </td>
                    <td v-if="currentUser.is_not_guest">
                        <slot :user="user"></slot>
                    </td>
                </tr>
            </tbody>
        </table>
        <h3 v-else>🤷‍♀️ No people could be found</h3>
    </div>
</template>
<script>

import { mapState } from 'vuex'
import Icon from '../Icon'
import RelativeTime from '../RelativeTime'
import Avatar from '../Avatar'

export default {
    props: {
        users: {
            required: true,
            type: Array
        },

        admin: {
            required: false,
            type: Boolean,
            default: false
        },

        showInviteButton: {
            required: false,
            default: true
        }
    },

    data () {
        return {
            query: ''
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        filteredUsers () {
            return this.users.filter((user) => {
                let regex = new RegExp(this.query, 'i')

                return regex.test(user.display_name) || regex.test(user.email)
            })
        },

        hasUsers () {
            return this.filteredUsers.length > 0
        }
    },

    components: {
        Icon,
        RelativeTime,
        Avatar
    }
}
</script>
